import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync, LL_H_C, LL_V_L, TS_CollapsableContainer } from '@nu-art/thunderstorm-frontend';
import { _keys, _values, MUSTNeverHappenException } from '@nu-art/ts-common';
import { DataGrid, ICONS } from '@app/styles';
import { DBDef_Action, DBDef_OrderGroup } from '@app/pathway-shared';
import { ModuleFE_PathwayState } from '../../../_entity/pathway-state/index.js';
import { ModuleFE_Action } from '../../../_entity/action/index.js';
import { ModuleFE_OrderGroup } from '../../../_entity/order-group/index.js';
import { Renderer_OrderExpressionIndicator } from './Renderer_OrderExpressionIndicator.js';
const OrderTypeToLabel = {
    'nurseIds': 'Nurse',
    'testsIds': 'Tests',
    'consultIds': 'Consult',
    'treatmentsIds': 'Treatments',
    'preconditions': 'Target State Preconditions'
};
export class Renderer_TransitionOrders extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        const orderKeys = ['treatmentsIds', 'nurseIds', 'testsIds', 'consultIds'];
        const transition = this.props.transition;
        let transitionOrderMapper = _keys(transition).reduce((mapper, currKey) => {
            if (orderKeys.includes(currKey))
                mapper[currKey] = transition[currKey];
            return mapper;
        }, {});
        const targetState = ModuleFE_PathwayState.cache.unique(transition.targetId);
        if (!targetState)
            throw new MUSTNeverHappenException(`cannot find state with id ${transition.targetId}`);
        transitionOrderMapper = { preconditions: targetState.preconditions.map(precon => precon.itemPointer), ...transitionOrderMapper };
        return _jsx(LL_H_C, { className: 'section-value', children: _jsx(TS_CollapsableContainer, { headerRenderer: () => _jsx("div", { className: 'collapsable-label', children: "Orders" }), containerRenderer: () => {
                    if (!_values(transitionOrderMapper).flat().length)
                        return _jsx("div", { style: {
                                lineHeight: '20px',
                            }, className: 'no-result-line', children: "No orders..." });
                    return _jsx(DataGrid.Grid, { className: 'order-grid', children: _keys(transitionOrderMapper)?.map((orderTypeKey, index) => {
                            const pointers = transitionOrderMapper[orderTypeKey];
                            return _jsxs(React.Fragment, { children: [_jsx(DataGrid.Label, { children: OrderTypeToLabel[orderTypeKey] }), _jsxs(LL_V_L, { children: [!pointers.length && _jsx("div", { style: { lineHeight: '20px', }, children: "-" }), !!pointers.length && pointers.map((pointer, index) => {
                                                switch (pointer?.dbKey) {
                                                    case DBDef_Action.dbKey: {
                                                        const order = ModuleFE_Action.cache.unique(pointer.id);
                                                        return _jsxs(LL_H_C, { className: 'order-expression-row', style: { lineHeight: '20px' }, children: [order?.name ?? 'N/A', order && _jsx(Renderer_OrderExpressionIndicator, { orderId: order._id, editMode: false, expressionId: pointer.expressionId })] }, index);
                                                    }
                                                    case DBDef_OrderGroup.dbKey: {
                                                        const group = ModuleFE_OrderGroup.cache.unique(pointer.id);
                                                        return _jsx("div", { style: { lineHeight: '20px' }, children: group?.name ?? 'N/A' }, index);
                                                    }
                                                }
                                            })] })] }, index);
                        }) });
                }, customCaret: _jsx(ICONS.advisorArrowDown.component, {}) }) });
    }
}
//# sourceMappingURL=Renderer_TransitionOrders.js.map